import { createSlice } from '@reduxjs/toolkit';
import { categoryGetByID } from './categoryAsyncThunk';

const categoryGetByIDSlice = createSlice({
  name: "category",
  initialState: {
    payload: [],
    isLoading: false,
    successCode: 0,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [categoryGetByID.pending]: (state, action) => {
      state.isLoading = true;
      state.successCode = 0;
      state.isFail = false;
    },
    [categoryGetByID.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.successCode = action.payload.id;
      state.payload = [...action.payload.list];
    },
    [categoryGetByID.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default categoryGetByIDSlice.reducer;